import type { TrackState } from '@melodinai/types';
import { useMixerStore } from '../../stores/mixerStore';

const SENDS = [
  { i: 0, label: 'A · Reverb' },
  { i: 1, label: 'B · Delay' },
  { i: 2, label: 'C · Parallel' },
  { i: 3, label: 'D · FX' },
];

interface SendsSectionProps {
  track: TrackState;
}

export function SendsSection({ track }: SendsSectionProps) {
  const setSend = useMixerStore((s) => s.setSend);
  const setSendPre = useMixerStore((s) => s.setSendPre);
  const sends = track.sends || [0, 0, 0, 0];

  if (track.type === 'master' || track.type === 'return') return null;

  return (
    <section className="space-y-2 border-b border-ssl-metal/50 pb-3">
      <div className="flex items-center justify-between">
        <h3 className="text-[10px] font-semibold uppercase tracking-[0.14em] text-ssl-accent">Sends</h3>
        <label className="flex items-center gap-1 text-[9px] text-ssl-muted">
          <input
            type="checkbox"
            checked={!!track.sendPre}
            onChange={(e) => setSendPre(track.id, e.target.checked)}
          />
          Pre
        </label>
      </div>
      <div className="space-y-1.5 rounded border border-ssl-metal/40 bg-black/20 p-2">
        {SENDS.map(({ i, label }) => (
          <label key={i} className="flex items-center gap-2 text-[9px] text-ssl-muted">
            <span className="w-20">{label}</span>
            <input
              type="range"
              min={0}
              max={1}
              step={0.01}
              value={sends[i] ?? 0}
              onChange={(e) => setSend(track.id, i, Number(e.target.value))}
              className="h-1 flex-1 accent-ssl-led"
            />
            <span className="w-8 tabular-nums text-right">{Math.round((sends[i] || 0) * 100)}</span>
          </label>
        ))}
      </div>
    </section>
  );
}
